import React from 'react';
import { langObj } from "../locale/index";
import ar from "../locale/ar.json";
import config from "../config.json";

let _l = localStorage.getItem('lang') || config.defaultLang;
let l_data = langObj[_l] ? langObj[_l] : ar;
export const LangCtx = React.createContext(l_data);

export const PayLoadCtx = React.createContext(null);

export const RoleCtx = React.createContext(null);

export const FileCtx = React.createContext(null);

export const SignalerCtx = React.createContext(null);

export const InstavcCtx = React.createContext(null);

export const StatesCtx = React.createContext(null);

export const CitiesCtx = React.createContext(null);

export const BloodgroupCtx = React.createContext(null);

export const DepartmentsCtx = React.createContext(null);

export const DiseasesCtx = React.createContext(null);

export const DiagonisisCtx = React.createContext(null);

export const QualificationCtx = React.createContext(null);

export const SpecializationsCtx = React.createContext(null);

export const localRecordingCtx = React.createContext(null);

export const GroupChatCtx = React.createContext(null);
